module.exports = "<div style=\"height: 75vh;\">\n  <h5>Olá <strong>{{ nameUser1 }}</strong> ! Seja bem vindo(a) ao PCdoc RM. </h5>\n</div>\n<ngx-loading [show]=\"loading\" [config]=\"{ backdropBorderRadius: '3px' }\" ></ngx-loading>"


//////////////////
// WEBPACK FOOTER
// /app/src/app/components/home/home.component.html
// module id = ../../../../../src/app/components/home/home.component.html
// module chunks = main